import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import StepContent from '../../../components/WhatsApp/StepContent';
import SupportBanner from '../../../components/WhatsApp/SupportBanner';
import WizardButtons from '../../../components/WhatsApp/WizardButtons';
import WizardProgress from '../../../components/WhatsApp/WizardProgress';
import useFBAuthenticated from '../../../hooks/useFBAuthenticated';
import useWhatsAppOnboarding from '../../../hooks/useWhatsAppOnboarding';

const GettingStarted = () => {
  const {
    step,
    setStep,
    eligibilityStep,
    setEligibilityStep,
    connectionOption,
    phoneValidationOption,
    subStep,
    existingStep,
    stepStatus,
    eligibilityStatus,
    handleOptionChange,
    handlePhoneValidationChange,
    handleGetStarted,
    handleEligibilityNext,
    handleExistingNext,
    handleBackStep,
  } = useWhatsAppOnboarding();

  const { access_token } = useSelector((state) => state.auth.user);
  const { isAuthenticated } = useFBAuthenticated(access_token);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginStatus, setLoginStatus] = useState('');
  const [selectedPhoneData, setSelectedPhoneData] = useState({ phoneId: null, wabaId: null });
  const navigate = useNavigate();

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setLoginStatus('');
    setStep(4);
  };

  const handleLoginFailed = () => {
    setIsLoggedIn(false);
    setLoginStatus('FAILED');
  };

  const handlePhoneNumberSelect = (data) => {
    setSelectedPhoneData(data);
  };

  const handleComplete = () => {
    if (selectedPhoneData.wabaId && selectedPhoneData.phoneId) {
      // Navigate to the detailed path with waba_id and phone_id
      navigate(
        `/dashboard/whatsapp/phone-number-details/${selectedPhoneData.wabaId}/${selectedPhoneData.phoneId}`
      );
    } else {
      // Fallback to the default path
      navigate('/dashboard/whatsapp');
    }
  };

  return (
    <div className="GettingStartedPage">
      <div className="GettingStartedCard">
        <WizardProgress stepStatus={stepStatus} />

        <div className="content-section">
          <StepContent
            step={step}
            connectionOption={connectionOption}
            existingStep={existingStep}
            eligibilityStatus={eligibilityStatus}
            eligibilityStep={eligibilityStep}
            setEligibilityStep={setEligibilityStep}
            phoneValidationOption={phoneValidationOption}
            subStep={subStep}
            onOptionChange={handleOptionChange}
            onPhoneValidationChange={handlePhoneValidationChange}
            loginStatus={loginStatus}
            isLoggedIn={isLoggedIn}
            onPhoneNumberSelect={handlePhoneNumberSelect}
          />
        </div>

        <WizardButtons
          step={step}
          setStep={setStep}
          connectionOption={connectionOption}
          eligibilityStep={eligibilityStep}
          existingStep={existingStep}
          subStep={subStep}
          setEligibilityStep={setEligibilityStep}
          handleGetStarted={handleGetStarted}
          handleEligibilityNext={handleEligibilityNext}
          handleExistingNext={handleExistingNext}
          handleBackStep={handleBackStep}
          onLoginSuccess={handleLoginSuccess}
          onLoginFailed={handleLoginFailed}
          accessToken={access_token}
          onComplete={handleComplete}
        />
      </div>
      <SupportBanner />
    </div>
  );
};

export default GettingStarted;
